export default {
    syncs: [],
    sync: {}
  }